import { API_HOST, getHttpGetOptions, getHttpPutOptions, getHttpPostOptions } from '../../../utils/api-util';

const getEndpoint = () => `${API_HOST}/admin/product-management`;

const getSendForAmendmentEndpoint = () => `${getEndpoint()}/amend`;
export const getSendForAmendmentRequest = (amendment) => [getSendForAmendmentEndpoint(), getHttpPostOptions(amendment)];

const getViewProductListingsEndpoint = () => `${getEndpoint()}/view/product/listings`;
export const getViewProductListingsRequest = (filters) => [
  getViewProductListingsEndpoint(),
  getHttpPostOptions(filters),
];

const getRetrieveProductListingEndpoint = (externalReference) =>
  `${getEndpoint()}/retrieve/product/listing/${externalReference}`;
export const getRetrieveProductListingRequest = (externalReference) => [
  getRetrieveProductListingEndpoint(externalReference),
  getHttpGetOptions(),
];

const getUpdateProductListingEndpoint = () => `${getEndpoint()}/update/product/listing`;
export const getUpdateProductListingRequest = (listing) => [
  getUpdateProductListingEndpoint(),
  getHttpPutOptions(listing),
];

const getViewBuyerListingsEndpoint = () => `${getEndpoint()}/view/buyer/listings`;
export const getViewBuyerListingsRequest = (filters) => [getViewBuyerListingsEndpoint(), getHttpPostOptions(filters)];

const getRetrieveBuyerListingEndpoint = (externalReference) =>
  `${getEndpoint()}/retrieve/buyer/listing/${externalReference}`;
export const getRetrieveBuyerListingRequest = (externalReference) => [
  getRetrieveBuyerListingEndpoint(externalReference),
  getHttpGetOptions(),
];

const getUpdateBuyerListingEndpoint = () => `${getEndpoint()}/update/buyer/listing`;
export const getUpdateBuyerListingRequest = (listing) => [getUpdateBuyerListingEndpoint(), getHttpPutOptions(listing)];

const getViewAccountsEndpoint = () => `${getEndpoint()}/view/accounts`;
export const getViewAccountsRequest = () => [getViewAccountsEndpoint(), getHttpGetOptions()];

const getApproveProductEndpoint = (externalReference) => `${getEndpoint()}/approve/${externalReference}`;
export const getApproveProductRequest = (externalReference) => [
  getApproveProductEndpoint(externalReference),
  getHttpGetOptions(),
];
